import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import { useHistory } from "react-router";
import { handleErrorBlock } from "../utils/error";
import {
  fetchLastStripeInvoiceDetails,
  createStripeInvoice,
} from "../services/StripeInvoiceService";
import { toast } from "react-toastify";
import { getContent } from "../localization";
import { Helmet } from "react-helmet";
import FullScreenLoader from "../components/FullScreenLoader";
import { FiXCircle } from "react-icons/fi";
import AddCustomerInfo from "../components/AddCustomerInfo";
import DashboardTableError from "../components/DashboardComponents/DashboardTableError";

function AddStripeInvoicePage(props) {
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(false);
  const [showCC, setShowCC] = useState(false);

  const [isLoading, setIsLoading] = useState(null);
  const [showFullScreenLoader, setShowFullScreenLoader] = useState(null);
  const [lastInvoice, setLastInvoice] = useState(null);
  const language = useSelector((state) => state.language);

  const [email, setEmail] = useState("");
  const [checked, setChecked] = useState(false);
  const [stripeBillingDto, setStripeBillingDto] = useState(null);
  const [sendInvoice, setSendInvoice] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [notes, setNotes] = useState("");

  const previousValue = useRef(null);

  const [itemList, setItemList] = useState([
    {
      amount: 0,
      name: "",
      transactionFee: 0,
      totalAmount: 0,
    },
  ]);

  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchLastInvoice();
  }, []);

  const { transactionChargeDtoMap } = useSelector(
    (state) => state.dashboardConfig
  );

  const profileDetails = useSelector((state) => state.profileDetails);

  const fetchLastInvoice = async () => {
    setIsLoading(true);
    await fetchLastStripeInvoiceDetails()
      .then((res) => {
        setLastInvoice(res.data);
        setStripeBillingDto(res.data);
        if (res.data) {
          setEmail(res.data.emailAddress);
        }
        setIsLoading(false);
        setShowFullScreenLoader(true);
        previousValue.current = res.data.emailAddress;
        if (res.data.emailAddress !== profileDetails.email) {
          setShowCC(true);
          if (res.data.enableCC) {
            setChecked(true);
          }
        } else {
          setShowCC(false);
          setChecked(false);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setShowFullScreenLoader(true);
        setError(true);
        setLastInvoice(null);
        setStripeBillingDto(null);
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error("Something went wrong. Please try again.");
        }
        handleErrorBlock(
          "Last invoice: Error ->",
          err,
          history,
          dispatch,
          false
        );
      });
  };

  const handleRetry = () => {
    fetchLastInvoice();
    setRetry(!retry);
  };

  let handleChange = (i, e) => {
    let newFormValues = [...itemList];
    newFormValues[i][e.target.name] = e.target.value;
    if (e.target.name == "amount") {
      const amount = e.target.value ? e.target.value : 0;
      const tax = transactionChargeDtoMap?.["STRIPE"]?.transactionCharge || 0;
      const total_tax = tax * 0.01 * parseFloat(amount);
      const total_amount = parseFloat(amount) + total_tax;
      newFormValues[i].totalAmount = parseFloat(total_amount).toFixed(2);
      newFormValues[i].transactionFee = parseFloat(total_tax).toFixed(2);
    }
    setItemList(newFormValues);
  };

  const addNewItem = () => {
    const newData = {
      amount: 0,
      name: "",
      transactionFee: 0,
      totalAmount: 0,
    };

    setItemList([...itemList, newData]);
  };

  let removeItem = (i) => {
    let newFormValues = [...itemList];
    newFormValues.splice(i, 1);
    setItemList(newFormValues);
  };

  const saveCustomerInfo = (params) => {
    console.log(params);
    setStripeBillingDto(params);
    setEmail(params.emailAddress);
  };

  const subTotal = itemList.reduce(
    (total, currentValue) =>
      (total =
        total + parseFloat(currentValue.amount ? currentValue.amount : 0)),
    0
  );
  const totalTax = itemList.reduce(
    (total, currentValue) =>
      (total =
        total + parseFloat(currentValue.totalAmount - currentValue.amount)),
    0
  );
  const grandTotal = itemList.reduce(
    (total, currentValue) =>
      (total =
        total +
        parseFloat(currentValue.totalAmount ? currentValue.totalAmount : 0)),
    0
  );

  let handleSubmit = async (event) => {
    event.preventDefault();
    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    if (
      !stripeBillingDto.emailAddress ||
      stripeBillingDto.emailAddress.length === 0
    ) {
      toast.error("You have not enter your email");
      return;
    } else if (
      !stripeBillingDto.emailAddress ||
      regex.test(stripeBillingDto.emailAddress) === false
    ) {
      toast.error("You have not enter Valid email");
      return;
    }

    stripeBillingDto["enableCC"] = checked;
    const data = {
      sendInvoice: sendInvoice,
      amount: parseFloat(subTotal),
      totalAmount: parseFloat(grandTotal),
      transactionFee: parseFloat(totalTax),
      transactionChargeDto: {
        currencyType: transactionChargeDtoMap?.["STRIPE"]?.currencyType || "USD",
        transactionCharge: transactionChargeDtoMap?.["STRIPE"]?.transactionCharge || 0,
      },
      itemList: itemList.map(item => ({
        ...item,
        amount: parseFloat(item.amount),
        totalAmount: parseFloat(item.totalAmount),
        transactionFee: parseFloat(item.transactionFee),
      })),
      stripeBillingDto: stripeBillingDto,
      notes: notes || "",
    };

    setIsLoading(true);
    await createStripeInvoice(data)
      .then((res) => {
        if (res.status === 200 && res.data) {
          setIsLoading(false);
          console.log(res.data);
          if (res.data?.invoiceUrl) {
            window.open(res.data.invoiceUrl, "_blank");
          }
          history.push(`/advertiser/stripe-invoice`);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error("Something went wrong. Please try again.");
        }
      });
  };

  const onBlurEmail = (e) => {
    setEmail(e.target.value);

    if (lastInvoice?.enableCC) {
      setChecked(lastInvoice.enableCC);
    }
    
    if (!stripeBillingDto) {
      resetData(e);
    } else {
      // Only update the email address, preserve other customer details
      const updatedBillingDto = {
        ...stripeBillingDto,
        emailAddress: e.target.value,
      };
      setStripeBillingDto(updatedBillingDto);
    }
    
    if (e.target.value !== profileDetails.email) {
      setShowCC(true);
    } else {
      setShowCC(false);
    }

    // Only reset data if email is completely different from the original
    if (previousValue.current !== e.target.value && !stripeBillingDto) {
      resetData(e);
    }

    previousValue.current = e.target.value;
  };

  const resetData = (e) => {
    setStripeBillingDto({
      billingAddress: {
        addressLine1: null,
        addressLine2: null,
        country: null,
        additionalInfo: null,
        postalCode: null,
        vatNumber: null,
      },
      companyName: null,
      emailAddress: e.target.value,
      firstName: null,
      lastName: null,
    });
  };
  return (
    <>
      <Helmet>
        <title>{getContent(language, "META_TITLE_ADD_STRIPE_INVOICE")}</title>
        <meta
          name="description"
          content={getContent(language, "META_DESCRIPTION_ADD_STRIPE_INVOICE")}
        />
      </Helmet>

      {showFullScreenLoader === true && error === false && (
        <div className="card mt-2">
          <div className="card-body invoice-form-container">
            <div className=" d-flex flex-column " style={{ flex: 1 }}>
              <div className="d-flex justify-content-end ">
                <FloatingLabel
                  controlId="currency"
                  label="Currency"
                  className="mb-3"
                  style={{ width: 120 }}
                >
                  <Form.Control
                    type="text"
                    value={transactionChargeDtoMap?.["STRIPE"]?.currencyType || "USD"}
                    disabled
                  />
                </FloatingLabel>
              </div>
              <p style={{ fontSize: "1.125rem" }}>Bill to:</p>
              <FloatingLabel
                controlId="email"
                label="Email Address"
                className=""
              >
                <Form.Control
                  type="email"
                  value={email}
                  onChange={(e) => {
                    onBlurEmail(e);
                  }}
                />
              </FloatingLabel>
              {showCC ? (
                <Form.Check
                  className="mt-2 mb-2"
                  label={`CC : ${profileDetails.email}`}
                  name="enableCC"
                  type={"checkbox"}
                  checked={checked}
                  onChange={() => {
                    setChecked(!checked);
                  }}
                />
              ) : null}
              {stripeBillingDto && (
                <div className="d-flex flex-column text-theme">
                  <div style={{ fontSize: ".8125rem" }}>
                    {stripeBillingDto?.companyName ? (
                      <>
                        {stripeBillingDto?.companyName}
                        <br />
                      </>
                    ) : null}

                    {stripeBillingDto?.firstName ||
                    stripeBillingDto?.lastName ? (
                      <>
                        {stripeBillingDto?.firstName}{" "}
                        {stripeBillingDto?.lastName}
                        <br />
                      </>
                    ) : null}

                    {stripeBillingDto.billingAddress?.addressLine1}
                    {stripeBillingDto.billingAddress?.addressLine1 ? (
                      <br />
                    ) : null}
                    {stripeBillingDto.billingAddress?.addressLine2}
                    {stripeBillingDto.billingAddress?.addressLine2 ? (
                      <br />
                    ) : null}
                    {stripeBillingDto.billingAddress?.postalCode}
                    {stripeBillingDto.billingAddress?.postalCode ? ", " : null}
                    {stripeBillingDto.billingAddress?.country}

                    {stripeBillingDto.billingAddress?.vatNumber ? (
                      <>
                        <br />
                        VAT Number: {stripeBillingDto.billingAddress?.vatNumber}
                      </>
                    ) : null}
                  </div>
                  <b
                    style={{
                      fontSize: 14,
                      color: "#34006b",
                      width: "fit-content",
                    }}
                    className="mt-2 cursor-pointer"
                    onClick={() => {
                      setModalShow(true);
                    }}
                  >
                    Edit customer information
                  </b>
                </div>
              )}
              <div
                className="mb-3 mt-3 text-theme"
                style={{ fontSize: "1.125rem" }}
              >
                Items
              </div>
              <form onSubmit={handleSubmit}>
                <div>
                  {itemList &&
                    itemList.length > 0 &&
                    itemList.map((item, index) => {
                      return (
                        <div className="invoice-item-container">
                          <div className="row">
                            <div className="col-sm-6">
                              <FloatingLabel
                                controlId="name"
                                label="Description *"
                                className="mb-3"
                              >
                                <Form.Control
                                  name="name"
                                  type="text"
                                  value={item.name || ""}
                                  onChange={(e) => handleChange(index, e)}
                                  required
                                />
                              </FloatingLabel>
                            </div>
                            <div className="col-sm-2">
                              <FloatingLabel
                                controlId="amount"
                                label="Price *"
                                className="mb-3"
                              >
                                <Form.Control
                                  name="amount"
                                  type="number"
                                  min={0}
                                  value={item.amount || ""}
                                  onChange={(e) => handleChange(index, e)}
                                  required
                                />
                              </FloatingLabel>
                            </div>
                            <div className="col-sm-2">
                              <FloatingLabel
                                controlId="Quantity"
                                label="Quantity"
                                className="mb-3"
                              >
                                <Form.Control
                                  name="quantity"
                                  type="text"
                                  value={"1"}
                                  disabled
                                />
                              </FloatingLabel>
                            </div>

                            <div className="col-sm-2">
                              <FloatingLabel
                                controlId="tax"
                                label="Tax"
                                className="mb-3"
                              >
                                <Form.Control
                                  type="text"
                                  min={0}
                                  placeholder="No Tax"
                                  value={`${transactionChargeDtoMap?.["STRIPE"]?.transactionCharge || 0} %`}
                                  disabled
                                />
                              </FloatingLabel>
                            </div>

                            <div className="col-sm-12">
                              {/* Description field removed for Stripe invoices */}
                            </div>
                          </div>
                          <div className="text-end">
                            <strong
                              style={{ color: "#687173", fontSize: ".8125rem" }}
                            >
                              Amount:{" "}
                              <span
                                className="ms-2 text-theme"
                                style={{ fontSize: ".9375rem" }}
                              >
                                ${parseFloat(item.totalAmount).toFixed(2)}
                              </span>
                            </strong>
                          </div>
                          {index > 0 && (
                            <FiXCircle
                              className="position-absolute top-50 cursor-pointer"
                              style={{
                                right: -35,
                                fontSize: 25,
                                color: "#D41E45",
                              }}
                              onClick={() => removeItem(index)}
                            />
                          )}
                        </div>
                      );
                    })}
                </div>
                <div
                  onClick={addNewItem}
                  className="cursor-pointer text-theme"
                  style={{
                    width: "fit-content",
                    fontWeight: 600,
                    fontSize: ".9375rem",
                  }}
                >
                  + Add Item or Service
                </div>
                <hr />
                <div className="row mt-3 mb-3">
                  <div className="col-md-12">
                    <FloatingLabel
                      controlId="notes"
                      label="Notes (Optional)"
                      className="mb-3"
                    >
                      <Form.Control
                        className="text-theme"
                        as="textarea"
                        name="notes"
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        style={{ height: "80px" }}
                        placeholder="Add any additional notes for this invoice"
                      />
                    </FloatingLabel>
                  </div>
                </div>
                <hr />
                <div className="row mt-3 mb-3">
                  <div className="col-md-9"></div>
                  <div className="col-md-3 d-flex flex-row justify-content-between">
                    <b style={{ color: "#687173", fontSize: ".8125rem" }}>
                      Sub Total :{" "}
                    </b>
                    <b
                      className="me-3 text-theme"
                      style={{ fontSize: ".9375rem" }}
                    >
                      ${parseFloat(subTotal).toFixed(2)}
                    </b>
                  </div>
                </div>
                <div className="row mt-3 mb-3">
                  <div className="col-md-9"></div>
                  <div className="col-md-3 d-flex flex-row justify-content-between">
                    <b style={{ color: "#687173", fontSize: ".8125rem" }}>
                      Total Tax :{" "}
                    </b>
                    <b
                      className="me-3 text-theme"
                      style={{ fontSize: ".9375rem" }}
                    >
                      ${parseFloat(totalTax).toFixed(2)}
                    </b>
                  </div>
                </div>
                <div className="row mt-3 mb-3">
                  <div className="col-md-9"></div>
                  <div className="col-md-3 d-flex flex-row justify-content-between">
                    <b style={{ color: "#687173", fontSize: ".8125rem" }}>
                      Total Amount :{" "}
                    </b>
                    <b
                      className="me-3 text-theme"
                      style={{ fontSize: ".9375rem" }}
                    >
                      ${parseFloat(grandTotal).toFixed(2)}
                    </b>
                  </div>
                </div>
                <hr />
                <div className="text-end">
                  <button
                    type="submit"
                    name="submit"
                    className="btn text-white m-3 mt-0 fw-bold bg-theme-minor px-4 mt-4 addWebButton shadow"
                    onClick={() => setSendInvoice(false)}
                  >
                    Save as Draft
                  </button>

                  <button
                    type="submit"
                    name="submit"
                    className="btn text-white m-3 mt-0 fw-bold bg-theme-minor px-4 mt-4 addWebButton shadow"
                    onClick={() => setSendInvoice(true)}
                  >
                    Send
                  </button>
                </div>
              </form>
            </div>
          </div>

          {modalShow ? (
            <AddCustomerInfo
              show={modalShow}
              onHide={() => setModalShow(false)}
              saveCustomerInfo={saveCustomerInfo}
              paypalBillingDto={stripeBillingDto}
            />
          ) : null}
        </div>
      )}

      {error === true && isLoading === false && (
        <DashboardTableError onRetry={handleRetry} />
      )}
      {isLoading ? <FullScreenLoader /> : null}
    </>
  );
}

export default AddStripeInvoicePage;